<template>
  <div>
    <b-modal @close="onClose" v-model="isModalOpen" :title="title" centered hide-footer no-close-on-backdrop>
      <img :src="require('@/assets/images/banner/20250411_meet.jpeg')" width="100%" />
    </b-modal>
  </div>
</template>

<script>
import { BModal, BButton, VBModal } from "bootstrap-vue";
export default {
  components: {
    BModal, BButton, VBModal
  },
  data() {
    return {
      isModalOpen: false,
      title: 'Ao vivo',
      key: '20250411_meet'
    };
  },
  mounted() {
    const currentDate = new Date();
    const endDate = new Date('2025-04-11T23:59:59-03:00');

    const alreadyShow = localStorage.getItem('home-banner') === this.key;
    if (!alreadyShow && currentDate.getTime() < endDate.getTime()) {
      this.isModalOpen = true;
    }
  },
  methods: {
    onClose() {
      this.isModalOpen = false;
      localStorage.setItem('home-banner', this.key);
    }
  }
};
</script>

<style scoped>
</style>
